import { render, staticRenderFns } from "./step_6.vue?vue&type=template&id=0126f4d1&"
import script from "./step_6.vue?vue&type=script&lang=js&"
export * from "./step_6.vue?vue&type=script&lang=js&"
import style0 from "./step_6.vue?vue&type=style&index=0&id=0126f4d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports